export default "<style>\n  \n</style>";